const styles = {
  link: {
    color: '#FFFFC0',
    textDecoration: 'none',
  },
};

const HelpContent = () => (
  <>
    <h4>Quick Start</h4>
    <ul>
      <li>Use the <b>Map Theme drop-down</b> to change the information that is displayed on the map</li>
      <li>Use the <b>Boundaries drop-down</b> to change the geographic boundaries used to display information on the map.  As you zoom in, you may want to change the boundary to Census Tracts or Census Blocks to show a more detailed view</li>
      <li><b>Click on an area on the map</b> to see detailed information about that area</li>
      <li>When you zoom in on the map to street level, you will see address points appear
        <ul>
          <li><b>Underserved</b> is any location with service below 100 Mbps download speed and 20 Mbps upload speed (denoted by 100/20)</li>
          <li><b>Unserved</b> is any location with broadband service below below 25 Mbps download speed and 3 Mbps upload speed (denoted by 25/3)</li>
        </ul>
      </li>
      <li>Use the Search bar to find and zoom to a specific location.</li>
      <li>All <b>broadband speeds are shown in Down/Up Mbps</b>.  For example, 100/20 indicates 100 Mbps download speed and 20 Mbps upload speed.</li>
    </ul>

    <h4>Map Themes Drop-Down</h4>
    <ul>
      <li>
        You can change the information displayed on the map by using the drop-down in the upper left of the map.  Each Theme will display different data related to broadband coverage and availability
        <ul>
          <li>Service Coverage 100/20 - indicates the % of locations within a geographical area that have access to at least 100 Mpbs download and 20 Mbps upload speeds</li>
          <li>Service Coverage 25/3 - indicates the % of locations within a geographical area that have access to at least 25 Mpbs download and 3 Mbps upload speeds</li>
          <li>Competition - indicates the % of locations within a geographical area that have access to at least 2 or more providers</li>
          <li>Maximum Speed - indicates the maximum speed available within a geographical area</li>
        </ul>
      </li>
    </ul>

    <h4>Map Boundaries Drop-Down</h4>
    <ul>
      <li>
        You can select between the following geographic boundaries using the Boundaries drop-down
        <ul>
          <li>Counties</li>
          <li>Municipalities</li>
          <li>Census Tracts</li>
          <li>Census Blocks</li>
        </ul>
      </li>
      <li>As you zoom in, you may want to change the boundary to Census Tracts or Census Blocks to show a more detailed view</li>
    </ul>

    <h4>Using the Search Bar</h4>
    <ul>
      <li>In the Search bar, you can type in a specific address.  As you type, close matches will display.  When you see the address you are looking for, select it and the map will zoom to that location</li>
      <li>The address search bar will also allow you to search by Municipality, County, Census Block or Census Tract, depending on the selection in the Boundaries drop-down.  For example, if you have &#39;County&#39; selected in the Boundary drop-down, you will be able to search for either a County or an Address in the search bar.</li>
      <li>To search for a new address, click on the &#39;X&#39; at the right of the search bar to clear the current address/location and search for a new one</li>
    </ul>

    <h4>Detailed Information Display</h4>
    <ul>
      <li>
        To see more detailed information about an area, click on the map.  The area you clicked will highlight and you will see information about that area on the right, including:
        <ul>
          <li>Name of the geographic area selected</li>
          <li>Total number of broadband serviceable locations in that area</li>
          <li>A set of stacked bar charts showing Service Coverage (percent of Server, Underserved, and Unserved locations), Maximum Speed, and Number of Providers</li>
          <li>A table with a list of Providers that serve within that area, including technology, speed and percent of locations served by that provider</li>
        </ul>
      </li>
      <li>
        When a Census Tract is selected you will see a breakdown of additional demographic information including Internet Subscriptions, Household Income, Race, Ethnicity, and Age.
      </li>
    </ul>

    <h4>Map Feedback and Contact</h4>
    <ul>
      <li>Click on the &#34;Map Feedback&#34; link at the top of the provider table to provide feedback about the map or to report an issue.</li>
      <li>Click on the &#34;Contact Us&#34; link to send an email to <a style={styles.link} href="mailto:mapfeedback@masstech.org" target="_blank" rel="noopener noreferrer">mapfeedback@masstech.org</a></li>
    </ul>
  </>
);

export default HelpContent;
